import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false;

const decodeHTML = function (str) {
  return str.replace(/&#(\d+);/g, function (match, dec) {
    return String.fromCharCode(dec);
  });
}

const translations = {
  "en_EN": {},
  "de_DE": {
    "Medium": "Medium",
    "Temperature": "Temperatur",
    "Pressure":"Druck",
    "Certificates": "Zertifikate",
    "Certificates:": "Zertifikate:",
    "Industries:": "Branchen:",
    "Performance": "Leistungsfähigkeit",
    "1 Best performance": "1 Beste Leistung",
    "2 or better": "2 oder besser",
    "3 or better": "3 oder besser",
    "Products": "Produkte",
    "No materials": "Kein Material",
    "Selecting gaskets with pT diagrams": "Dichtungsauswahl mit Hilfe des pT- Diagrammes",
    "Maximum temperature and pressure values alone can not define a material’s suitability for an application. These limits are dependent upon a multiplicity of factors like flanges, bolts, installation, process control, fluctuating loads an so on. The pT diagram therefore provides only guidelines.": "Maximale Anwendungstemperatur und maximaler Betriebsdruck alleine definieren nicht die Eignung eines Dichtungsmaterials für eine bestimmte Anwendung. Die maximale Einsatzfähigkeit von Dichtungen definiert sich über eine Vielzahl von Einflussgrößen wie Flansche, Schrauben, Einbau der Dichtung, Prozessführung, Spannungsschwankungen usw. Das pT Diagramm ermöglicht daher nur eine überschlägige Abschätzung der Einsatzfähigkeit.",
    "pT-diagram": "pT – Diagramm",
    "- thickness": "- Materialdicke",
    "In area one": "- In Feld 1",
    "In area two": "- In Feld 2",
    "In area three": "- In Feld 3",
    "the gasket material is normally suitable subject to chemical compatibility": "ist eine anwendungstechnische Überprüfung in der Regel nicht erforderlich. Überprüfen Sie immer die Medienbeständigkeit des Dichtungsmaterials für jeden geplanten Einsatzfall.",
    "the gasket material may be suitable but a technical evaluation is recommended": "empfehlen wir eine anwendungstechnische Überprüfung des gewählten Dichtungsmaterials. Überprüfen Sie immer die Medienbeständigkeit des Dichtungsmaterials für jeden geplanten Einsatzfall.",
    "do not install the gasket without a technical evaluation. Always refer to the chemical resistance of the gasket to the media.": "ist eine anwendungstechnische Überprüfung des gewählten Dichtungsmaterials grundsätzlich erforderlich. Überprüfen Sie immer die Medienbeständigkeit des Dichtungsmaterials für jeden geplanten Einsatzfall.",
    "PDF download": "PDF download",
    "Product documentation": "Produktdokumentation",
    "Shelf life": "Lagerfähigkeit",
    "Safety information": "Sicherheitsinformation",
    "Installation manual": "Einbauanleitung",
    "Gasket factors": "Dichtungskennwerte",
    "Klinger expert": "KLINGER®expert",
    "KLINGER®expert": "KLINGER®expert",
    "Approval overview": "Zulassungen Übersicht",
    "This material is chemically resistant to:": "Dieses Material ist chemisch beständig gegen:",
    "Sales partner": "Vertriebspartner",
    "Related links": "Weitere Links",
  },
}

Vue.filter('translate', function (value) {
  if (!value) return ''
  value = value.toString()
  let locale = !!document.getElementById('german') ? 'de_DE' : 'en_EN'
  return translations[locale][value] || value
});

new Vue({
  router,
  data: function () {
    let data = JSON.parse(document.getElementById('data').innerHTML);
    // let data = require('./data.json');
    let parsedData = Object.keys(data).map((i) => {
      data[i]['chemicals'] = data[i]['chemicals'].map((c) => {
        c.title = decodeHTML(c.title);
        return c;
      })
    })
    let locale = !!document.getElementById('german') ? 'de_DE' : 'en_EN';
    return {
      locale: locale,
      data: data,
      baseUrl: process.env.BASE_URL,
    }
  },
  render: h => h(App)
}).$mount('#material-selector')
